import React, { Fragment, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Modal, Form, Select, Upload, Input, Button, message } from 'antd';
import { Col, Row } from 'react-bootstrap';
import Card from '../../../components/bootstrap/card';
import { UploadOutlined, InboxOutlined } from '@ant-design/icons';
import {getAllAdminIECsService, GetLicenseNoService} from '../../../services/FileDataService';
import {getDropdownByName, getDropdownChildren} from '../../../services/DropdownService';
import { CreateClosuresService } from '../../../services/ClosureService';

const { Option } = Select;
const { Dragger } = Upload;
const FORM_TYPES = ['CLSR_ADV_AUTH', 'CLSR_EPCG', 'CLSR_BOND'];
const EXCEL_TYPES = ['CLSR_DRAWBACK', 'CLSR_RODTEP'];
const CLSR_STATUS_DROPDOWN_NAME = 'closure_status';
const CLSR_REMARK_DROPDOWN_NAME = 'closure_remark';

const CreateClosures = (props) => {
    const [form] = Form.useForm();
    const [selectedType, setSelectedType] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [liabilityFile, setLiabilityFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [IECOptions, setIECOptions] = useState([]);
    const [selectedIEC, setSelectedIEC] = useState(localStorage.getItem('iec_no'));
    const [iecName, setIECName] = useState(localStorage.getItem('name'));
    const [userRole, setUserRole] = useState(localStorage.getItem('role'))
    const [licenseOptions, setLicenseOptions] = useState([]);
    const [selectedLicense, setSelectedLicense] = useState(null);


    const handleClose = () => {
        form.resetFields();
        setSelectedType(null);
        setFileList([]);
        setLiabilityFile(null);
        props.onClose();
    };

    const getAdminIEC = async () => {
        const token = localStorage.getItem('token');
        const response = await getAllAdminIECsService(token);
    
        if (response && response.data){
          let i = 0;
          const options = response.data.map(item => ({
            value: `${item.iec_no}`,
            label: `${item.iec_no} (${item.fullname})`,
            key: i++,
          }));
    
          setIECOptions(options);
        }
    }
 
    const fetchLicensesByIEC = async (iec_no) => {
        try {
            const token = localStorage.getItem('token');
            const response = await GetLicenseNoService(token, iec_no, props.type_name);
            if (response && response.data) {
                const options = response.data.map((license_no, index) => ({
                    value: license_no,
                    label: license_no,
                    key: index,
                }));
                setLicenseOptions(options);
            }
        } catch (error) {
            console.error("Error fetching licenses:", error);
        }
    };

    const handleSubmit = async () => {
        try {
            setLoading(true);
            const values = await form.validateFields();

            console.log("form values: ", values)
      
            const formData = new FormData();
            formData.append('type_name', props.type_name);
            formData.append('iec_no', selectedIEC);
            formData.append('license_no',selectedLicense)

            // Add form data for ADV_AUTH, EPCG, BOND
            if (FORM_TYPES.includes(props.type_name)) {
                console.log("form_data: ", JSON.stringify(values.formData))
                formData.append('form_data', JSON.stringify(values.formData));
            }

            // Add liability file for DRAWBACK, RODTEP
            if (EXCEL_TYPES.includes(props.type_name) && liabilityFile) {
                formData.append('liability_file', liabilityFile);
            }

            // Add supporting documents
            if (fileList.length > 0) {
                fileList.forEach(file => {
                    formData.append('documents', file);
                });
            }
            const formDataObj = Object.fromEntries(formData.entries());
            console.log("FormData as object:", formDataObj);

            const response = await CreateClosuresService(selectedIEC, props.type_name, formData);
            if (response){
                console.log(response);
                props.onSubmit()
            }
            handleClose();
        }
        catch (error) {
            console.error('Error creating closure:', error);
            message.error('Failed to create closure');
          } finally {
            setLoading(false);
        }
    }


    const documentsProps = {
        multiple: true,
        onRemove: (file) => {
          const index = fileList.indexOf(file);
          const newFileList = fileList.slice();
          newFileList.splice(index, 1);
          setFileList(newFileList);
        },
        beforeUpload: (file) => {
          setFileList([...fileList, file]);
          return false;
        },
        fileList,
    };

    const liabilityFileProps = {
        multiple: false,
        onRemove: () => {
          setLiabilityFile(null);
        },
        beforeUpload: (file) => {
          setLiabilityFile(file);
          return false;
        },
        fileList: liabilityFile ? [liabilityFile] : [],
    };

    const handleIECSelection = (val) => {
        console.log(val)
        if (val){
          let iec_no = val.split(";")[0];
          let iec_name = val.split(";")[1];
          setSelectedIEC(iec_no)
          setIECName(iec_name)
          fetchLicensesByIEC(iec_no);
          form.setFieldsValue({ formData: { license_no: null } });
        }
        else{
          setSelectedIEC(null);
          setIECName('');
          setSelectedLicense(null);
          setLicenseOptions([]);
          form.setFieldsValue({ formData: { license_no: null } });
        }
      }

    useEffect(() => {
        if(userRole == 'superadmin'){
            getAdminIEC();
        }
        else{
            fetchLicensesByIEC(selectedIEC);
        }
        
    }, [props.type_name]);

    return (
        <Modal
            title={"Create New Closure - " + props.type_name.replace(/CLSR_/g, "").replace(/_/g, " ")}
            open={props.visible}
            onOk={handleSubmit}
            onCancel={handleClose}
            width={800}
            confirmLoading={loading}
        >
            <Form
                form={form}
                layout="vertical"
            >

            {userRole && userRole == 'superadmin' &&
            <Form.Item
                name='iec_no'
                label="Select IEC"
                rules={[{ required: true, message: 'Please select IEC No' }]}
            >
                <Select
                    focus
                    showSearch
                    placeholder="Select IEC"
                    filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={handleIECSelection}
                    allowClear
                    options={IECOptions}
                    // style={{ width: '300px', float: 'right' }}
                />
            </Form.Item>
            }

            {props.type_name && FORM_TYPES.includes(props.type_name) && (
            <>
            <Form.Item
                name="formData"
                label="Closure Details"
                rules={[{ required: true, message: 'Please enter closure details' }]}
            >
                <Form.Item 
            name={['formData', 'license_no']} 
            label="License Number" 
            rules={[{ required: true, message: 'Please enter License Number' }]}>
                <Select
                    showSearch
                    placeholder="Select License Number"
                    value={selectedLicense}
                    filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(val) => setSelectedLicense(val)}
                    allowClear
                    options={licenseOptions}
                />
            </Form.Item>
                {/* Add your form fields here based on closure type */}
                <ClosureFormFields type={props.type_name} form={form} />
            </Form.Item>
            </>
            )}

            {props.type_name && EXCEL_TYPES.includes(props.type_name) && (
            <Form.Item
                name="liabilityFile"
                label="Liability Data File"
                rules={[{ required: true, message: 'Please upload liability data file' }]}
            >
                <Dragger {...liabilityFileProps} accept=".xlsx,.xls">
                <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                </p>
                <p className="ant-upload-text">Click or drag Excel file to upload</p>
                <p className="ant-upload-hint">
                    Please upload the liability data in Excel format
                </p>
                </Dragger>
            </Form.Item>
            )}

            <Form.Item
                name="documents"
                label="Supporting Documents"
            >
            <Upload {...documentsProps}>
                <Button icon={<UploadOutlined />}>Select Files</Button>
            </Upload>
            </Form.Item>
        </Form>
          
        </Modal>
    );

}


// Separate component for closure form fields
const ClosureFormFields = ({ type, form }) => {
    
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [statusOptions, setStatusOptions] = useState([]);
    const [remarkOptions, setRemarkOptions] = useState({});

    const getClosureFormDropdown = async () => {
        const response = await getDropdownByName(CLSR_STATUS_DROPDOWN_NAME);

        if(response){
            console.log("dropdown response: ", response);
            var statusDropdown = [];
            var remarkDropdown = {};
            response.forEach(item => {
                const option = {
                    id: item.dropdown_id,
                    value: item.option_value,
                    label: item.option_label
                }

                statusDropdown.push(option);
            })

            setStatusOptions(statusDropdown);
        }
    }

    // Get form instance to manipulate fields
    // const [form] = Form.useForm();

    const handleStatusChange = async (value, option) => {
        console.log("option: ", option)
        const parentId = option.id;
        setSelectedStatus(value);

        // Reset both the form field and the Select component's value
        form.setFieldsValue({
            formData: {
                ...form.getFieldValue('formData'),
                remark: undefined
            }
        });
        setRemarkOptions([]);

        // Populate children remark dropdown
        const children = await getDropdownChildren(CLSR_REMARK_DROPDOWN_NAME, parentId);
        var remarkDropdown = [];
        await children.forEach(child => {
            const option = {
                id: child.dropdown_id,
                value: child.option_value,
                label: child.option_label
            }
            remarkDropdown.push(option);
        })

        setRemarkOptions(remarkDropdown)
        
    };

    useEffect(() => {
        getClosureFormDropdown();
    }, [])

    return (
        <>

        {/* <Form.Item name={['formData', 'license_no']} label="License Number" rules={[{ required: true, message: 'Please enter License Number' }]}>
            <Input />
        </Form.Item> */}
        <Form.Item
            name={['formData', 'status']}
            label="Status"
            rules={[{ required: true, message: 'Please select status' }]}
        >
            <Select
            placeholder="Select Status"
            onChange={handleStatusChange}
            >
                {statusOptions.map(option => (
                    <Option key={option.value} value={option.value} id={option.id}>
                    {option.label}
                    </Option>
                ))}
            </Select>
        </Form.Item>

        
        {/* Remark Dropdown - Only shown if status is selected */}
        {selectedStatus && (
            <Form.Item
            name={['formData', 'remark']}
            label="Remark"
            rules={[{ required: true, message: 'Please select remark' }]}
            >
            <Select placeholder="Select Remark">
                {remarkOptions?.map(option => (
                <Option key={option.value} value={option.value}>
                    {option.label}
                </Option>
                ))}
            </Select>
            </Form.Item>
        )}

        <Form.Item name={['formData', 'param1']} label="Textbox 1">
            <Input/>
        </Form.Item>
        <Form.Item name={['formData', 'param2']} label="Textbox 2">
            <Input/>
        </Form.Item>
        <Form.Item name={['formData', 'param3']} label="Textbox 3">
            <Input/>
        </Form.Item>
        <Form.Item name={['formData', 'param4']} label="Textbox 4">
            <Input/>
        </Form.Item>
        </>
    );
      
};

export default CreateClosures;